<template>
  <v-container
    fluid
    fill-height
  >
    <v-row justify="center">
      <v-col sm="6">
        <v-card elevation="0">
          <div class="text-center flex-logo pa-2">
            <img
              src="../assets/logo-for-light-bg.svg"
              alt="AuthentiGate"
            >
          </div>
          <v-row justify="center">
            <v-col
              sm="8"
              lg="5"
            >
              <v-card>
                <v-skeleton-loader
                  v-if="loading"
                  type="card-heading, image, actions"
                />
                <div v-if="!loading">
                  <v-alert
                    v-if="hasError"
                    type="error"
                  >
                    Error: {{ errorMessage }}
                  </v-alert>
                  <div v-if="!hasError">
                    <v-card-title>
                      <h4>Hi {{ displayName }}</h4>
                    </v-card-title>
                    <v-form @submit.prevent="submit">
                      <v-card-text>
                        <p>
                          You received an invitation at
                          {{ email }} to sign a document with AuthentiGate.
                        </p>
                        <p>
                          <span class="font-weight-bold">Choose a password</span>
                          and we'll get you started.
                        </p>
                        <v-text-field
                          v-model="password"
                          :error-messages="passwordErrors"
                          label="Password"
                          type="password"
                          @input="$v.password.$touch()"
                          @blur="$v.password.$touch()"
                        />
                        <accept-terms v-model="termsAccepted" />
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          color="primary"
                          outlined
                          to="/"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer />
                        <v-btn
                          color="primary"
                          type="submit"
                          :disabled="formInvalid"
                          :loading="submitting"
                        >
                          Sign up
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import { auth } from '../firebase'
import AcceptTerms from '@/components/AcceptTerms'

export default {
  name: 'Invited',
  components: { AcceptTerms },
  mixins: [validationMixin],
  data() {
    return {
      displayName: null,
      documentId: null,
      email: null,
      errorMessage: null,
      hasError: null,
      inviteToken: null,
      loading: true,
      password: null,
      termsAccepted: false,
      submitting: false
    }
  },
  computed: {
    formInvalid() {
      return this.$v.$invalid || !this.termsAccepted
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      !this.$v.password.minLength &&
        errors.push(
          `Password must have at least ${this.$v.password.$params.minLength.min} characters`
        )
      return errors
    }
  },
  async created() {
    this.inviteToken = this.$route.params.inviteToken
    try {
      const {
        data: {
          user: { displayName, email, hasLogin },
          documentId
        }
      } = await this.$fireGet(this.invitationUrl())
      this.displayName = displayName
      this.email = email
      this.documentId = documentId
      if (hasLogin) {
        this.redirectToDashboard()
      }
    } catch (e) {
      this.redirectToDashboard()
    }
    this.loading = false
  },
  methods: {
    invitationUrl(path = '') {
      return `signature/invitation/${encodeURIComponent(
        this.inviteToken
      )}${path}`
    },
    async submit() {
      this.submitting = true
      try {
        await this.$firePost(this.invitationUrl('/set-password'), null, {
          password: this.password,
          termsAccepted: this.termsAccepted
        })
        await this.login()
      } catch (e) {
        this.handleError(e)
      }
      this.submitting = false
    },
    async login() {
      await auth.signInWithEmailAndPassword(this.email, this.password)
      this.redirectToDashboard()
    },
    handleError(error) {
      this.hasError = true
      let errorMessage
      if (error.isAxiosError) {
        const { response: { data: { message } = {} } = {} } = error
        errorMessage = message
      }
      if (errorMessage) {
        this.errorMessage = errorMessage
      } else {
        this.$Sentry.captureException(error)
        this.errorMessage =
          'There was an issue with your invitation. Please contact support.'
      }
    },
    redirectToDashboard() {
      this.$router.push({
        path: '/dashboard',
        query: { toSign: this.documentId }
      }).catch(() => {})
    }
  },
  validations: {
    password: { required, minLength: minLength(7) }
  }
}
</script>
